export default "__VITE_ASSET__BZjSgKCX__"